import { createContext, useContext } from "react";

const GalleryPickerContext = createContext(null);

/** The app supplies the media module; shared controls never import a module. */
export function GalleryPickerProvider({ component, children }) {
  return (
    <GalleryPickerContext.Provider value={component}>
      {children}
    </GalleryPickerContext.Provider>
  );
}

/** Renders the existing gallery with its original selection contract and markup. */
export function GalleryPicker(props) {
  const Component = useContext(GalleryPickerContext);
  if (!Component) {
    throw new Error("GalleryPickerProvider must be configured by the panel app.");
  }
  return <Component {...props} />;
}
